import { render, staticRenderFns } from "./mobileAssistant.vue?vue&type=template&id=94bf4770&scoped=true"
import script from "./mobileAssistant.vue?vue&type=script&lang=js"
export * from "./mobileAssistant.vue?vue&type=script&lang=js"
import style0 from "./mobileAssistant.vue?vue&type=style&index=0&id=94bf4770&prod&lang=less&scoped=true"
import style1 from "./mobileAssistant.vue?vue&type=style&index=1&id=94bf4770&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bf4770",
  null
  
)

export default component.exports